export default function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/inline-style-prefixer/es/utils/isObject.js
// module id = 211
// module chunks = 1